import { URLSearchParams } from "@angular/http";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Rx";
import { Subject } from "rxjs/Subject";

import { loginConfig } from "../../config/config";
import { User } from "../../models/users/user";
import { news } from "../../config/config";

/**
 * 登录认证服务
 *
 * @export
 * @class LoginService
 */
@Injectable()
export class LoginService {
  private loginUrl: string;
  private userSource: Subject<User>; // 观察者userSource，注册或登录成功后发射当前用户
  public isLoggedIn: boolean; // 登录标志
  public token: string;

  constructor(private http: HttpClient) {
    this.isLoggedIn = false;
    this.userSource = new Subject<User>();
    this.loginUrl = loginConfig.loginUrl;
  }
  getNews(type: any) {
    return this.http.get(news.listType + '?type=' + type, {})
  }
  getPicture() {
    return this.http.get(news.listPicture , {})
  }
  getImg(fileid: any) {
    return this.http.get(news.getImg + '?fileid=' + fileid, {})
  }
  getCarousel() {
    return this.http.get(news.getCarousel, {})
  }
  getDown(id: any) {
    return this.http.get(news.download + '?id=' + id, {})
  }
  /**
   * 设置当前用户，发射一个user
   * @param user
   */
  setUser(user: User) {
    this.userSource.next(user);
    // 如果为null则为退出登录
    if (user) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
  }

  /**
   * 获取当前登录用户
   *
   * @returns {Observable<User>}
   * @memberof AuthService
   */
  get currentUser(): Observable<User> {
    return this.userSource.asObservable();
  }

  /**
   *
   * 注册用户
   *
   * @param {User} user
   * @returns {Observable<Object>}
   * @memberof AuthService
   */
  register(user: User): Observable<Object> {
    const body = new URLSearchParams();
    body.set("UserName", user.UserName);
    body.set("PWD", user.PWD);
    // const body = JSON.stringify(user);
    const headers = new HttpHeaders().set("Content-Type", "application/json");

    return this.http
      .post(`${this.loginUrl}/register`, body.toString(), { headers: headers })
      .map(res => this.setToken(res));
  }

  /**
   * 用户登录
   *
   * @param {User} user
   * @returns {Observable<Object>}
   * @memberof AuthService
   */
  login(user: User): Observable<Object> {

    // const body = new URLSearchParams();
    // body.set("UserName", user.UserName);
    // body.set("PWD", user.PWD);

    // const headers = new HttpHeaders().set(
    //   "Content-Type",
    //   "application/x-www-form-urlencoded"
    // );
    // return this.http
    //   .post(`${this.loginUrl}`, body.toString(), {
    //     headers: headers
    //   })
    //   .map(res => this.setToken(res));


    let formData = new FormData();

    formData.append("username", user.UserName);
    formData.append("password", user.PWD);


    return this.http
      .post(this.loginUrl, formData)
      .map(res => this.setToken(res));
  }




  loginA(user: User): Observable<Object> {
    // const body = JSON.stringify(user);
    // const headers = new HttpHeaders().set("Content-Type", "application/json");
    const body = new URLSearchParams();
    body.set("UserName", user.UserName);
    body.set("Password", user.PWD);
    // 以x-www-form-urlencoded形式提交数据
    const headers = new HttpHeaders().set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    return this.http
      .post(loginConfig.loginAUrl, body.toString(), {
        headers: headers
      })
      .map(res => this.setToken(res));
  }



  /**
   * 退出登录
   *
   * @memberof AuthService
   */
  logout(): void {
    this.token = null;
    sessionStorage.removeItem("currentUser");
    sessionStorage.removeItem("id")
    this.setUser(null);
  }

  /**
   * 登录成功后，设置token，存储在sessionStorage中
   *
   * @param {any} res
   * @returns {*}
   * @memberof AuthService
   */
  setToken(res): any {
    if (res["message"] == "SUCCESS") {
      this.token = res["token"];
      sessionStorage.setItem(
        "currentUser",
        JSON.stringify({
          user: res["user"],
          token: this.token
        })
      );
    } else if (res["message"] == null) {
      sessionStorage.setItem(
        "currentUser",
        JSON.stringify({
          user: res
        })
      );
    }
    return res;
  }


  // setToken(res): any {
  //   if (res["m_type"] === 1) {
  //     sessionStorage.setItem(
  //       "currentUser",
  //       JSON.stringify({
  //         userName: res["m_objResultData"]["m_strUser"],
  //         role: res["m_objResultData"]["m_strRoleName"],
  //         department: res["m_objResultData"]["m_strDepartment"],
  //         mobile: res["m_objResultData"]["m_strMobile"]
  //       })
  //     );
  //   }
  //   return res;
  // }

  /**
   * 验证用户是否登录
   *
   * @returns
   * @memberof AuthService
   */
  verify(): Observable<Object> {
    const currUser = JSON.parse(sessionStorage.getItem("currentUser"));
    const token = currUser && "token" in currUser ? currUser.token : this.token;
    const headers = new HttpHeaders({ "x-access-token": token });
    return this.http
      .get(`${this.loginUrl}/check-state`, { headers: headers })
      .map(res => JSON.parse(res["_body"]));
  }
}
